import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
var AuxTotemComponent = /** @class */ (function () {
    function AuxTotemComponent(dialog, _router) {
        this.dialog = dialog;
        this._router = _router;
    }
    AuxTotemComponent.prototype.sign = function (tipo) {
        //  alert(tipo);
        if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
            this.dialog.closeAll();
            if (tipo == 'totem-busqueda-direccion') {
                this._router.navigate(["/totem-busqueda-direccion"]);
            }
        }
        else {
            if (tipo == 'totem-busqueda-direccion') {
                //console.log("expediente 2");
                this._router.navigate(["/totem-busqueda-direccion"]);
            }
        }
        this.dialog.closeAll();
    };
    return AuxTotemComponent;
}());
export { AuxTotemComponent };
